import { Component, Input, OnDestroy } from '@angular/core';
import { TranslatorService } from '../../../services/translator_service';
import { ResponsiveService } from '../../../services/responsive.service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslatePipe } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { ProgressBarColor } from '../../../widgets/progress-bar-color/progress-bar-color';
import { CommonModule } from '@angular/common';
import { ApiStore } from '../../../web-services/api/api.store';
import { ApiService } from '../../../web-services/api/api.service';
import { takeUntil } from 'rxjs/operators';
import { combineLatest, Subject } from 'rxjs';
import { UtilService } from '../../../services/util.service';

@Component({
  selector: 'app-bin-metrics',
  imports: [CommonModule,NgCircleProgressModule,TranslatePipe,RTLDivDirectiveDirective,ProgressBarColor],
  templateUrl: './bin-metrics.html',
  styleUrl: './bin-metrics.scss',
})
export class BinMetrics {
  isMobile: boolean;
	translationsObj;
	currentLang;
  	capacityLevelUnfiltered = 0;
	capacityLevel = 0;
	capacityDisplayType: number = 0;
	usageType = 1;
	user_role_id = 0;
	binBatteryLevel = 0;
	binTemprature = '0';
	binTemperatureLow = -20;
	binTemperatureHigh = 90;
	binHumidityLow = 0;
	binHumidityHigh = 100;
  	binHumidity = '0';
	currentBatteryStatus: string = '';
	bin_type_id = -1;
	original_bin_type_id = -1;
	enableActiveQuickSamplingPlan = false;
	activateClick = false;
	stopClick = false;
	selectedBinInfo: any = null;
	private readonly destroy$ = new Subject<void>();

	constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiQuery:ApiQuery,
    private apiService:ApiService,private apiStore:ApiStore,public utilService: UtilService) {
    this.translator.currentLangEmitter$
	.pipe(takeUntil(this.destroy$))
    .subscribe(async value=>{						
      this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
      this.currentLang = value;
    })
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
	combineLatest([
		this.apiQuery.binInfo$,
		this.apiQuery.user$,
	  ])
		.pipe(takeUntil(this.destroy$))
		.subscribe(([info, user]) => {
			this.selectedBinInfo = info;
			if (!user || !info) return;
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}
			this.user_role_id = user["user_role_id"];
			this.capacityDisplayType = user["user_default_capacity_type_id"];
			this.bin_type_id = this.selectedBinInfo.bin_type_id;			
			this.original_bin_type_id = this.selectedBinInfo.bin_type_for_reset;
			this.activateClick = false;
			this.stopClick = false;
			if(this.bin_type_id == 10){
				this.enableActiveQuickSamplingPlan = false;
			}else{
				this.enableActiveQuickSamplingPlan = true;
			}

			this.capacityLevelUnfiltered = this.selectedBinInfo.Bin_live_Data['fill_level_percent_unfiltered'];	
			this.capacityLevel = this.selectedBinInfo.Bin_live_Data.fill_level_percent;
			if (this.capacityDisplayType != 0) {
				this.capacityLevel = Math.round((this.selectedBinInfo.Bin_thresholds["bin_max_capacity_in_liters"]) * (this.selectedBinInfo.Bin_live_Data.fill_level_percent / 100));
			}	
			this.binBatteryLevel = this.selectedBinInfo.Bin_live_Data.battery_level;
			this.binTemprature = this.selectedBinInfo.Bin_live_Data.temperature.toString();
			this.binHumidity = this.selectedBinInfo.Bin_live_Data.humidity.toString();
			this.currentBatteryStatus = this.getBatteryLevelIcon();
	});
  }

  onResize() {
    this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getBatteryLevelIcon() {
    if (this.binBatteryLevel >= 0 && this.binBatteryLevel <= 25) {
      return 'assets/images/binInfoPage/battery_level_critical.svg';
    }else if (this.binBatteryLevel >= 26 && this.binBatteryLevel <= 50) {
      return 'assets/images/binInfoPage/battery_level_low.svg';
    }else if (this.binBatteryLevel >= 51 && this.binBatteryLevel <= 75) {
      return 'assets/images/binInfoPage/battery_level_normal.svg';
    }
    return 'assets/images/binInfoPage/battery_level_good.svg';		
	}

  activateQuickSamplingPlan() {
		if(this.activateClick){
			return;
		}
		this.activateClick = true;
		const dataToSend = {
			"bin_type" : "10",
			"num_of_hours_for_bin_type_reset" : 1,
			"bin_id_list" : [[Number(this.selectedBinInfo.bin_id),Number(this.selectedBinInfo.cluster_id)]]			
		};
		this.apiService.setBinThresholdsAndRestrictions(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
			this.apiService.getBinInfo(this.selectedBinInfo.bin_id);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}

	stopQuickSamplingPlan() {
		if(this.stopClick){
			return;
		}
		this.stopClick = true;
		const dataToSend = {
			"bin_type" : this.original_bin_type_id,
			"num_of_hours_for_bin_type_reset" : 0,
			"bin_id_list" : [[Number(this.selectedBinInfo.bin_id),Number(this.selectedBinInfo.cluster_id)]]			
		};
		this.apiService.setBinThresholdsAndRestrictions(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
			this.apiService.getBinInfo(this.selectedBinInfo.bin_id);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}
}
